import { combineReducers, configureStore } from "@reduxjs/toolkit";
import globalReducers from "./global/globalReducers";
import prosesPendaftaranReducers from "./prosesPendaftaran/prosesPendaftaranReducers";
import tenderUmumReducers from "./tenderUmum/tenderUmumReducers";
import registrasiReducers from "./registrasi/registrasiReducers";
import formReducers from "./form/formReducers";
import sessionReducers from "./session/sessionReducers";

const store = configureStore({
  reducer: combineReducers({
    global: globalReducers,
    form: formReducers,
    prosesPendaftaran: prosesPendaftaranReducers,
    tenderUmum: tenderUmumReducers,
    registrasi: registrasiReducers,
    session: sessionReducers,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
